import { SearchPage } from "./search-page.model";
import { ApiConsumer } from "./api-consumer.model";

export class ApiConsumerList extends SearchPage {
  results: ApiConsumer[] = [];
}
